import React from 'react';
import { Navigate } from 'react-router';
import { Loader } from '@thinknet-gmbh/platform-common-ui';
import { MemberTypesEnum } from '@thinknet-gmbh/platform-common';

import { usePermissionContext } from '../../contexts';
import { useGetOwnData } from 'src/hooks/employees/get-own-data.hook';

import { ROUTES } from '../app/app-routes.constants';

const PermissionRouteGuard = ({
  children,
  permission,
  rule,
}: {
  children?: React.ReactNode;
  permission: string;
  rule: string;
}) => {
  const { permissions } = usePermissionContext();

  const { employee, loading } = useGetOwnData();

  if (loading) {
    return <Loader />;
  }

  if (String(employee?.type) === String(MemberTypesEnum.OWNER)) {
    return <>{children}</>;
  }

  const checkIfHadPermission = (permission?: string, rule?: string) =>
    permissions.find(item => item?.permission === permission && item?.rule === rule);



  return checkIfHadPermission(permission, rule) ? (
    <>{children}</>
  ) : (
    <Navigate to={{ pathname: ROUTES.dashboard }} />
  );
};

export default PermissionRouteGuard;
